export default "__VITE_ASSET__DGDpzuSE__"